import React, { useState } from "react";
import Layout from "../../../NewComponent/Layout/Layout";
import LayoutCM from "../../../NewComponent/LayoutCM/Layout";
import LayoutExpert from "../../../NewComponent/LayoutExpert/Layout";
import { getBriefHistory,getBriefHistoryCount } from "../../../API/api";
import { useEffect } from "react";
import { Spin, Pagination } from "antd";
import Table from "./Table";
import { CURRENT_ROLE } from "../../../API/url";
export default function Saved() {
  const [data, setdData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const getBriefData = () => {
    setLoading(true);
    getBriefHistory(CURRENT_ROLE !=='CM'?false:true,page).then((res) => {
      if (res === undefined) {
        return;
      }
      setdData(res.data.data['records']);
      setLoading(false);
    });
  };
  const getBriefCount = () => {
    if(page === 0){
      getBriefHistoryCount(CURRENT_ROLE !=='CM'?false:true).then((res) => {
      if (res === undefined) {
        return;
      }
      setCount(res.data.data['count']);
    });
    }
  };
  useEffect(() => {
    getBriefCount();
    getBriefData();
  }, [page]);
  const containerStyles = {
    width: "90%",
    margin: "auto",
    marginTop: "1%",
    marginBottom: "7%",
    border: "1px solid #ffffff",
    boxShadow: "0px 4px 16px 0px #1018280F",
    borderRadius: "12px",
    minHeight: "500px",
    padding: "24px",
    boxShadow: "7px 7px 20px lightgrey",
    background:'#ffffff'
    // display:'flex',
    // justifyContent:'space-between'
  };
  const ansStyles = {
    marginBottom: "15px",
    fontSize: "22px",
    color: "#5C667B",
    lineHeight: "24px",
    fontWeight: "500",
    wordBreak: 'break-word',overflowWrap: 'break-word',
    
  };
  return (
    <>
      {CURRENT_ROLE === "Seeker" &&<Layout>
        <Spin spinning={isLoading} size="large">
          {" "}
          <div style={containerStyles}>
            <div style={ansStyles}>
              View Saved Briefs
            </div>
            {!isLoading &&<Table data={data} onClickFunc={getBriefData}/>}
            {!isLoading &&<div className="mt-2" style={{ display: "flex", justifyContent: "end" }}>
              <Pagination total={count} current={page + 1} onChange={(e)=>setPage(e-1)} showSizeChanger={false} pageSize={20} />
            </div>}
          </div>
        </Spin>
      </Layout>}
      {CURRENT_ROLE === "Expert" &&<LayoutExpert>
        <Spin spinning={isLoading} size="large">
          {" "}
          <div style={containerStyles}>
            <div style={ansStyles}>
              View Saved Briefs
            </div>
            {!isLoading &&<Table data={data} onClickFunc={getBriefData}/>}
            {!isLoading &&<div className="mt-2" style={{ display: "flex", justifyContent: "end" }}>
              <Pagination total={count} current={page + 1} onChange={(e)=>setPage(e-1)} showSizeChanger={false} pageSize={20} />
            </div>}
          </div>
        </Spin>
      </LayoutExpert>}
      {CURRENT_ROLE === "CM" &&<LayoutCM>
        <Spin spinning={isLoading} size="large">
          {" "}
          <div style={containerStyles}>
            <div style={ansStyles}>
              View Saved Briefs
            </div>
            {!isLoading &&<Table data={data} onClickFunc={getBriefData}/>}
            {!isLoading &&<div className="mt-2" style={{ display: "flex", justifyContent: "end" }}>
              <Pagination total={count} current={page + 1} onChange={(e)=>setPage(e-1)} showSizeChanger={false} pageSize={10} />
            </div>}
          </div>
        </Spin>
      </LayoutCM>}
    </>
  );
}
